import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DsTagModule } from '@bmw-ds/components';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'tqc-boolean-cell-renderer',
  standalone: true,
  imports: [DsTagModule, TranslatePipe],
  templateUrl: './boolean-cell-renderer.component.html',
  styleUrl: './boolean-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BooleanCellRendererComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams | undefined;

  agInit(params: ICellRendererParams) {
    this.params = params;
  }
  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }
}
